import { useSelector } from "react-redux";

import { Button, IconButton, Tooltip } from "@similarweb/ui-components";

import {
    MANAGEMENT_COMMON_DISABLED_TOOLTIP_LOADING,
    SL_MANAGEMENT_DISABLED_TOOLTIP,
} from "app/pages/sales-intelligence/pages/management/translations/managementKeys";
import { useAccountAdminsQuery } from "app/pages/sales-intelligence/query/queries/useAccountAdminsQuery";
import { selectHasListOwnedByCurrentUser } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/suppressionListSelectors";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { SL_MANAGEMENT_CREATE_LIST } from "../../../../translations/loadListKeys";
import { SL_MANAGEMENT_FILE_BTN_TEXT_REPLACE } from "../../../../translations/modals";

interface IProps {
    className?: string;
    onClick: VoidFunction;
    isDisabled: boolean;
}

export const UploadSuppressionListButton = ({ className, onClick, isDisabled }: IProps) => {
    const translate = useTranslation();
    const isReplace = useSelector(selectHasListOwnedByCurrentUser);
    const accountAdmins = useAccountAdminsQuery();

    const label = translate(isReplace ? SL_MANAGEMENT_FILE_BTN_TEXT_REPLACE : SL_MANAGEMENT_CREATE_LIST);
    const tooltipContent = isDisabled
        ? `${translate(SL_MANAGEMENT_DISABLED_TOOLTIP)}:\n${accountAdmins.data?.join("\n") || MANAGEMENT_COMMON_DISABLED_TOOLTIP_LOADING}`
        : "";
    return (
        <Tooltip
            enabled={isDisabled}
            content={tooltipContent}
        >
            {isReplace ? (
                <Button
                    className={className}
                    isDisabled={isDisabled}
                    type="primary"
                    onClick={onClick}
                >
                    {label}
                </Button>
            ) : (
                <IconButton
                    className={className}
                    isDisabled={isDisabled}
                    type="primary"
                    iconName="upload-file"
                    onClick={onClick}
                >
                    {label}
                </IconButton>
            )}
        </Tooltip>
    );
};
